import api from '../api';
import { CreateNafListData, NafList, UpdateNafListData } from '../types/nafList';

/**
 * Get all NAF lists for the user's company
 */
export const getNafLists = async (): Promise<NafList[]> => {
  const response = await api.get('/naf-lists');
  return response.data;
};

/**
 * Get a specific NAF list by ID
 */
export const getNafListById = async (id: number): Promise<NafList> => {
  const response = await api.get(`/naf-lists/${id}`);
  return response.data;
};

/**
 * Create a new NAF list
 */
export const createNafList = async (data: CreateNafListData): Promise<NafList> => {
  const response = await api.post('/naf-lists', data);
  return response.data;
};

/**
 * Update a NAF list
 */
export const updateNafList = async (id: number, data: UpdateNafListData): Promise<NafList> => {
  const response = await api.put(`/naf-lists/${id}`, data);
  return response.data;
};

/**
 * Delete a NAF list
 */
export const deleteNafList = async (id: number): Promise<void> => {
  await api.delete(`/naf-lists/${id}`);
};

/**
 * Search NAF lists by name
 */
export const searchNafLists = async (query: string): Promise<NafList[]> => {
  const response = await api.get(`/naf-lists/search/${encodeURIComponent(query)}`);
  return response.data;
}; 